/**
 * The checkout registration keeps its step and its entries in localStorage so a reload does
 * not lose them. Once the customer is logged in — the address step or the payment step — the
 * saved state is stale and has to go, or the next guest on the same browser inherits it.
 */
const KEYS = [
    'registrationFrame',
    'accOpen',
    'showBillingForm',
    'displayRegBillUserEmail',
    'form.regHomeForm',
    'form.regFilialeForm',
    'form.regPickupForm',
    'form.loginForm',
];

export function clearRegistrationState() {
    KEYS.forEach((key) => localStorage.removeItem(key));
}

export { KEYS as REGISTRATION_STATE_KEYS };
